<template>
  <el-dialog title="审核" width="500px" :visible="auditShow" :close-on-click-modal="false" @close='closeDialog'>
    <el-form :model="info" ref="info" label-width="80px">
      <el-form-item label="审核结果" prop="approvalStatus" required>
        <el-radio v-model="info.approvalStatus" :label="3" border>通过</el-radio>
        <el-radio v-model="info.approvalStatus" :label="4" border>驳回</el-radio>
      </el-form-item>
      <el-form-item label="审核备注" prop="handleBak">
        <el-input
          type="textarea"
          maxlength="100"
          placeholder="请输入审核备注"
          :rows="4"
          show-word-limit
          v-model="info.handleBak"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'IssueAudit',
  props: {
    auditShow: Boolean,
    issueId: String
  },
  data () {
    return {
      info: {
        approvalStatus: 3,
        handleBak: ''
      },
      submitShow: false
    }
  },
  created () {
    // ...
  },
  methods: {
    onSubmit () {
      this.submitShow = true
      this.$axios.post(this.$apis.patrol.approvalIssue, {
        issueId: this.issueId,
        ...this.info
      }).then(() => {
        this.$message.success('审核成功')
        this.$emit('success')
        this.closeDialog()
      }).finally(() => {
        this.submitShow = false
      })
    },
    // 关闭
    closeDialog () {
      this.$emit('update:auditShow', false)
      this.$refs.info.resetFields()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
